// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zQdhS","index":"styles_index__2jyJG"};